import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PublicLayout from "@/components/PublicLayout";
import HomePage from "@/pages/HomePage";
import FleetPage from "@/pages/FleetPage";
import CarDetailPage from "@/pages/CarDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import BookingCancelledPage from "@/pages/BookingCancelledPage";
import CustomQuotePage from "@/pages/CustomQuotePage";
import SuspendedPage from "@/pages/SuspendedPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverviewPage from "@/pages/admin/AdminOverviewPage";
import AdminCarsPage from "@/pages/admin/AdminCarsPage";
import AdminBookingsPage from "@/pages/admin/AdminBookingsPage";
import AdminQuotesPage from "@/pages/admin/AdminQuotesPage";
import AdminLeadsPage from "@/pages/admin/AdminLeadsPage";
import AdminWingmanPage from "@/pages/admin/AdminWingmanPage";
import AdminBillingPage from "@/pages/admin/AdminBillingPage";
import { PaywallProvider, usePaywall } from "@/context/PaywallContext";

function PublicRoutesGate() {
  const { suspended, loading } = usePaywall();
  if (loading) return null; // brief flash avoided
  if (suspended) return <SuspendedPage />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/fleet" element={<FleetPage />} />
        <Route path="/cars/:id" element={<CarDetailPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/quote" element={<CustomQuotePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/booking/success" element={<BookingSuccessPage />} />
        <Route path="/booking/cancelled" element={<BookingCancelledPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <PaywallProvider>
          <Routes>
            {/* Admin always reachable so the owner can pay even while suspended */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminOverviewPage />} />
              <Route path="cars" element={<AdminCarsPage />} />
              <Route path="bookings" element={<AdminBookingsPage />} />
              <Route path="quotes" element={<AdminQuotesPage />} />
              <Route path="leads" element={<AdminLeadsPage />} />
              <Route path="wingman" element={<AdminWingmanPage />} />
              <Route path="billing" element={<AdminBillingPage />} />
            </Route>
            {/* Public routes gated by paywall */}
            <Route path="*" element={<PublicRoutesGate />} />
          </Routes>
        </PaywallProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
